
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/divine-manifestation",
      function () {
        return require("private-next-pages/divine-manifestation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/divine-manifestation"])
      });
    }
  